import { render, staticRenderFns } from "./AddingStageModal.vue?vue&type=template&id=4dcb1141&scoped=true&"
import script from "./AddingStageModal.vue?vue&type=script&lang=js&"
export * from "./AddingStageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb1141",
  null
  
)

export default component.exports